import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

const BannerImage = () => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "banner.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return <Img fluid={data?.image?.childImageSharp?.fluid} alt='Banner image' />;
};

export default BannerImage;
